import MenuService from "../services/MenuService";
import { addEventListeners, removeEventListeners } from "../utils/dom";
import { Collapse } from "bootstrap";

export default class NavTree extends HTMLUListElement {


    connectedCallback() {

        this.addEventListener("click", this.handleExpandClick);
        
    }

    disconnectedCallback() {

        removeEventListeners(".nav-tree-btn", "click", this.handleClick);

    }

    handleExpandClick = (e) => {

        let clickedBtn;

        if (e.target.matches(".nav-tree-btn")) {
            clickedBtn = e.target;
        }
        else if (e.target.closest(".nav-tree-btn") != null) {
            clickedBtn = e.target.closest(".nav-tree-btn");
        }
        else {
            return;
        }

        const pageId = clickedBtn.dataset.pageId;
        let target = document.getElementById(clickedBtn.getAttribute("aria-controls"));

        if (pageId && target === null) {
            this.loadItems(pageId)
                .then(data => {
                    target = document.createElement('ul');
                    target.className = "nav nav-tree collapse";
                    target.id = "nav-" + pageId;
                    target.innerHTML = this.renderItems(data.childPages);
                    clickedBtn.closest(".nav-item").appendChild(target);
                    clickedBtn.setAttribute("aria-controls", "nav-" + pageId);
                })
                .then(() => {
                    this.toggleCollapse(clickedBtn);
                });
        }
        else if (target !== null) {
            this.toggleCollapse(clickedBtn);
        }

    }

    /**
     * @param {number} pageId
     **/
    loadItems = (pageId) => {
        var menuService = new MenuService();

        return menuService.getChildren(pageId);
    }

    /**
     * @param {Array.<NavItem>} items
     **/
    renderItems(items) {
        return Array.from(items).map(item => {
            const linkCssClasses = ["nav-link font-weight-normal"];
            if (item.isCurrentPage) {
                linkCssClasses.push("current");
            }

            return `<li class="nav-item">
                ${item.hasChildren ? "<div class=\"nav-item-inner\">" : ""}
                <a href="${item.url}" class="${linkCssClasses.join(" ")}">${item.name}</a>
                <div class="nav-tree-btn-wrapper">${item.hasChildren ? this.renderBtn(item) : ""}</div>
                ${item.hasChildren ? "</div>" : ""}
            </li>`;
        }).join("");
    }

    /**
     * @param {NavItem} item
     **/
    renderBtn(item) {
        return `<button class="nav-tree-btn" aria-label="Undermeny för ${item.name}"
                         aria-expanded="false" data-page-id="${item.id}">
                    <svg class="icon-chevron-down icon" aria-hidden="true">
                        <use xlink:href="/bundles/icons/sprites.svg#icon-chevron-down"></use>
                    </svg>
                </button>`;
    }

    /**
     * @param {HTMLButtonElement} clickedBtn
     **/
    toggleCollapse = (clickedBtn) => {

        const target = document.getElementById(clickedBtn.getAttribute("aria-controls"));

        if (target === null) {
            this.loadItems().then()
        }

        const collapse = Collapse.getOrCreateInstance(target);

        if (clickedBtn.getAttribute("aria-expanded") === "true") {
            clickedBtn.setAttribute("aria-expanded", "false");
            collapse.hide();
        }
        else {
            clickedBtn.setAttribute("aria-expanded", "true");
            collapse.show();
        }

    }

}

customElements.define('nav-tree', NavTree, { extends: 'ul' });